import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.hasMotion ) {
        $( '.mega-cutout-cta' ).addClass( 'js-animated' );
        return;
      }

      $( '.mega-cutout-cta' ).each( function( key, component ) {
        let image = $( this ).find( '.fit-image img' )[0];
        if ( $( this ).find( '.loop-video-container' ).length ) {
          image = $( this ).find( '.loop-video-container' )[0];
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 80%',
            scrub: 0.15,
            onEnter: ( {progress, direction, isActive} ) => {
              $( component ).addClass( 'js-animated' );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( component ).addClass( 'js-animated' );
              }
            },
            // markers: true,
          },
        } );

        const parallax = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: 'bottom top',
            scrub: 0,
          },
        } );
        parallax.to( image, {y: '15%', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'mega-cutout-cta', COMPONENT );
} )( app );
